import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import {
	mapGessagemResponse,
	type CalcularGessagemResponse,
	type GessagemCalculationResult,
} from './gessagemResponse';

export interface CalcularGessagemPayload {
	adviceId: string;
	soilAnalysisId: string;
	productId: string;
	satCa2: number;
	forma: string;
	formaConfig: { p: number; l: number; c: number };
}

export function usePostAdviceCorrectionGessagem() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<GessagemCalculationResult, Error, CalcularGessagemPayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<CalcularGessagemResponse>(
					'/advices/planting/calcularGessagem',
					payload,
					{ params: { forBinding } }
				);
				return mapGessagemResponse(data);
			} catch (error) {
				throw toApiError(error, 'Erro ao calcular gessagem');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['correction', 'gessagem'] }),
		onError: (error) =>
			console.error(
				'Erro ao calcular gessagem:',
				getApiErrorMessage(error, 'Erro ao calcular gessagem')
			),
	});
}
